import { render, staticRenderFns } from "./DataDictionary.vue?vue&type=template&id=4e1f3bb9&scoped=true&"
import script from "./DataDictionary.vue?vue&type=script&lang=js&"
export * from "./DataDictionary.vue?vue&type=script&lang=js&"
import style0 from "./DataDictionary.vue?vue&type=style&index=0&id=4e1f3bb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1f3bb9",
  null
  
)

export default component.exports